import { Inject, Injectable, InjectionToken } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { WINDOW } from '@core/services/window.service';

export const LOCALSTORAGE = new InjectionToken<Storage>('Local Storage');

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    private readonly localStorageRef: Storage;

    private readonly dummyLocalStorage = {
        clear: () => {
            /*noop*/
        },
        getItem: (key: string) => undefined as string,
        key: (index: number) => undefined as string,
        removeItem: (key: string) => {
            /*noop*/
        },
        setItem: (key: string, value: string) => {
            /*noop*/
        },
        length: 0,
    };

    constructor(
        private environmentService: EnvironmentService,
        @Inject(WINDOW) window: Window
    ) {
        if (
            environmentService.isBrowser() &&
            navigator.cookieEnabled &&
            window.localStorage
        ) {
            this.localStorageRef = localStorage;
        } else {
            this.localStorageRef = this.dummyLocalStorage;
        }
    }

    get localStorage(): Storage {
        return this.localStorageRef;
    }
}
